module.exports = __webpack_public_path__ + "static/img/15.2a3adfe.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tic/qq/15.gif
// module id = Kvcu
// module chunks = 0